<template>
    <div>
        <b-list-group-item
            v-if="title"
            class="list-group-item-accent-secondary bg-light text-center font-weight-bold text-muted text-uppercase small"
        >
            {{ title }}
        </b-list-group-item>
        <b-list-group-item class="list-group-item-accent-light">
            <div class="float-right">
                <slot name="actionButton" />
            </div>
            <div class="text-muted text-uppercase title font-weight-bold small">
                {{ subtitle }}
            </div>
            <small v-if="description" class="text-muted mr-3">
                <i class="fa fa-angle-double-right fa-lg mr-2"></i>
                {{ description }}
            </small>
            <slot />
        </b-list-group-item>
    </div>
</template>

<script>
export default {
    name: 'SettingsList',
    props: ['title', 'subtitle', 'description'],
}
</script>
